// @ts-ignore
import { createStore, applyMiddleware, combineReducers } from "redux";
import promiseMiddleware from "./promise-middleware";
// @ts-ignore
import { getTypes } from "./actions-wrapper";

/**
 * extends the default redux behavior for reducers
 * now we can receive actions name list as types
 * and action result as action.
 * @example
 * reducer(state, {type, action, types});
 */
const formatActionData = (data) => ({
  type: data.type,
  action: data,
  types: getTypes()
});

/**
 * Unbox error object depends on place, and format the error message.
 * it can be coding error - actions, reducers, etc.
 * it can be response server side error.
 */
const createErrorMessage = (data) => {
  let message = {
    message: "Unexpected Error",
    description: ""
  };
  let isObject = data && data.constructor === Object;
  if (isObject) {
    if (data.data && data.data.error) {
      // Upgrade Required
      message = data.data.error;
      if (message.constructor === Object) {
        let concated = "";
        Object.values(message).forEach((mess) => {
          concated += `${mess} `;
        });
        message.description = concated;
      }
    } else {
      // when come from server side
      if (data.message || data.detail) {
        message = {
          message: data.title || message.message,
          description: data.detail
        };
      } else {
        Object.values(data).forEach((value) => {
          value &&
            value.error &&
            Object.keys(value.error).forEach((key) => {
              message.description += `${value.error[key]} `;
            });
        });
      }
    }
  } else {
    message = data;
  }

  return message;
};

/**
 * it proxies every action call with few hooks
 * for pure function action it trigger only response hook
 * for async / await trigger request -> response | error
 */
const definePromiseMiddlewareHooks = () => {
  return {
    response: (data, next) => next(formatActionData(data)),
    request: (data, next) => {
      data.type = `${data.type}Request`;
      next(formatActionData(data));
    },
    error: (data, next) => {
      let { error } = data;
      console.log(data);
      error = error
        ? error.stack
          ? { data: { error: { message: error } } }
          : error
        : { data: { error: { message: "" } } };

      let err =
        (error.data && error.data.error && error.data.error.error) || error;

      err = createErrorMessage(err);
      data.error = err;
      data.type = `${data.type}Error`;
      console.log(data);
      next(formatActionData(data));
    }
  };
};

/**
 * That moulde is defined Promise middleware for
 * https://github.com/pirateminds/redux-pirate-promise
 * and combine actions using the
 * https://github.com/pirateminds/redux-pirate-actions
 * We patch second argument for the default redux library
 * with {type, action, types}.
 * Where the types is the action list names.
 * As the result module returns the store.
 */
export default (data: any, reducers: any) => {
  let reducer = combineReducers(reducers);
  let finalCreateStore = applyMiddleware(
    promiseMiddleware.bind(undefined, definePromiseMiddlewareHooks())
  )(createStore);
  // @ts-ignore
  let store = finalCreateStore(
    reducer,
    data,
    typeof window !== "undefined"
      ? window.devToolsExtension && window.devToolsExtension()
      : undefined
  );

  return store;
};



// WEBPACK FOOTER //
// ./src/store/create-store.js